import type { Content } from '@prismicio/client';
import type { SliceComponentProps } from '@prismicio/react';
import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

import { HORIZONTAL_PADDING_MOBILE } from 'components/utilities/pageStyles';

type PrimarySliceData =
  SliceComponentProps<Content.HeroImageSlice>['slice']['primary'];

export const Background = styled.div<{
  image: PrimarySliceData['backgroundImage']['url'];
  fullWidth: PrimarySliceData['fullWidth'];
}>`
  padding: 0 ${({ fullWidth }) => (fullWidth ? 0 : HORIZONTAL_PADDING_MOBILE)};

  ${QUERIES.tabletAndUp} {
    background-image: url(${({ image }) => image});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
  }
`;

export const Image = styled.img<{
  customWidth: PrimarySliceData['customWidth'];
  imageStyle: PrimarySliceData['style'];
}>`
  display: block;
  position: relative;
  width: ${({ customWidth }) => customWidth || '800px'};
  max-width: 100%;
  margin: 0 auto;

  border-radius: ${themeStyle.radiusLarge};
  border-style: solid;
  border-width: ${({ imageStyle }) => (imageStyle === 'plain' ? '0' : '10px')};
  border-color: ${({ imageStyle }) =>
    imageStyle === 'plain' ? 'none' : themeStyle.inkBase};
  box-shadow: ${({ imageStyle }) =>
    imageStyle === 'plain' ? 'none' : themeStyle.shadowSoft};
`;
